module.exports = __webpack_public_path__ + "img/productos.a580f7c2.png";